import React from 'react';
import { MainContainer } from '../../component/container';
import Land from '../../assets/image/banneLand.gif'
import gif from '../../assets/video/gf.mp4'
import BouncingIcon from '../../component/BouncingIcon';
import { Element, Link } from 'react-scroll';
import { useNavigate } from 'react-router';

export default function Home() {
    const navigate = useNavigate();


    const Section = ({ title, children }) => {
        const calculerMoitieLongueur = (texte) => (texte ? Math.floor(texte.length / 2) : 0);

        const moitieLongueurTitre = calculerMoitieLongueur(title);

        return (
            <div className='mt-10 relative'>
                <span className="text-left font-extrabold text-2xl text-[#87ceeb] relative inline-block">
                    {title}
                    <span className="absolute inset-0 bg-gradient-to-r h-1 top-8 from-[#87ceeb] to-transparent" style={{ width: `calc(${moitieLongueurTitre}ch)` }}></span>


                </span>

                <div className='text-left text-lg mt-3'>
                    {children}
                </div>
            </div>
        );
    };

    const handleDonateClick = () => {
        navigate('/Donate#Dn');
    };


    return (
        <MainContainer page='HOME'>
            <div className=''>

                <div id='content' className="">

                    <video className="w-screen h-screen  object-cover opacity-90" autoPlay playsInline loop muted>
                        <source src={gif} type="video/mp4" />
                    </video>

                    <div className="w-full absolute top-1/2 left-0 transform -translate-y-1/2 2xl:px-80 xl:px-52 px-10">
                        <div className="bg-[#87ceeb]    bg-opacity-70 p-4 rounded-full">
                            <h1 className="text-lg sm:text-4xl font-bold text-white text-center">AMERO-CONGO RELIEF FOUNDATION INC.</h1>

                        </div>
                    </div>
                    <Link to="Scroll" smooth={true} duration={500}>
                        <BouncingIcon />
                    </Link>
                </div>
                <Element name="Scroll" className="element"><div className='min-h-[2px]'></div></Element>

                <div className='2xl:px-80 xl:px-52 px-10 mt-24'>



                    <Section title={"Caring for street children"}>
                        We are a non profit and charitable organization striving to restore the image of God on mankind by assisting and bringing hope to at risk children, generally called "street kids"in USA and in the Congo DRC.
                    </Section>

                    <Section title={"Mission and vision"}>
                        Our mission is to ensure that all children of any neighborhood, especially orphans and less fortunate abandoned children are given a chance to become a positive, active and vital part of our society. With this in mind, our vision is to contribute to the abolition of worldwide juvenile delinquency as well as different crimes that young people are involved in today.
                        <div className='mt-5'>
                            "By securing our youth's safety and education, we will secure the future of this world we are living in."
                        </div>
                    </Section>

                    <Section title={"Our projects"}>
                        <div className='font-extrabold text-[#2e51a9bc]'>
                            We have a great need to build an orphanage for the congolese orphans under our care.
                        </div>
                        Below is the land we possess to build an orphanage, a school and a health facility for our orphans in the Congo DRC. We need your support and contribution to make <span className='underline'>this project</span> a reality.

                        <div className='mt-5'>
                            Please, <span className='text-blue-800 underline cursor-pointer hover:opacity-30' onClick={() => { navigate('/Contact') }}>contact us</span> at your earliest!
                        </div>
                    </Section>

                    <div className=''>
                        <img src={Land} alt="Land" className='w-full' />
                    </div>

                    <Section>
                        <div className='text-[#2e51a9bc] font-extrabold'>
                            The building of this orphanage will help decrease the number of wondering orphans on the streets of Congo and allow us to closely monitor and manage their progress, while providing them with a secure place to live they can call "HOME", as well as an adequate education for self sufficiency.

                        </div>

                        <div className='mt-3'>
                            Please donate today and <span className='font-extrabold'> become a benefactor</span> as we continue saving the lives of street children in US and orphans in the Congo DRC.
                        </div>

                        <div className='mt-3'>
                            For your gift to save a life, please click on <span className='font-extrabold'>Donate below</span> and <span className='font-extrabold'>securely donate using PayPal;</span> or go to <span className='text-blue-800 underline cursor-pointer hover:opacity-30' onClick={() => { navigate('/Donate') }}>donate today</span> and choose a different way to send your donations. Thank you in advance for your caring heart!
                        </div>
                    </Section>

                    <div className='mt-3 flex flex-col items-center justify-center' onClick={handleDonateClick}>
                        <div className='bg-yellow-400 rounded p-2 cursor-pointer text-white'> Donate</div>
                        and make a difference in their lives today!
                    </div>
                </div>
            </div>
        </MainContainer>
    );
}